import React, { Component } from "react"
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import { translate } from "react-i18next"
import { MainWrapper, PageWrapper } from "./components/layout"
import { ROUTES } from "./constants"

import { Callback, SignInSilent, PreLoginSplash, SignInRequired } from "./routes/auth"

import Error404 from "./routes/errors/Error404"
import "./css/bootstrap/bootstrap.css"
import "./css/material-pro/css/horizontal.css"
import "./css/material-pro/css/theme.css"

class LoggedOutApp extends Component {
  state = {
    showMobileNav: false,
  }

  toggleMobileNav = () => {
    this.setState((prevState) => {
      return { showMobileNav: !prevState.showMobileNav }
    })
  }

  render() {
    return (
      <Router>
        {this.state.showMobileNav ? (
          <div>Mobile something here</div>
        ) : (
          <MainWrapper>
            <PageWrapper>
              <Switch>
                <Redirect exact from="/" to={ROUTES.auth.preLogin} />
                <Redirect strict from="/dashboard" to={ROUTES.auth.preLogin} />
                <Route path={ROUTES.auth.callback} component={Callback} />
                <Route path={ROUTES.auth.signInSilent} component={SignInSilent} />
                <Route path={ROUTES.auth.preLogin} component={PreLoginSplash} />
                <Route path={ROUTES.auth.signInRequired} component={SignInRequired} />
                <Route component={Error404} />
              </Switch>
            </PageWrapper>
          </MainWrapper>
        )}
      </Router>
    )
  }
}

export default translate()(LoggedOutApp)



// WEBPACK FOOTER //
// ./src/LoggedOutApp.jsx